import Vue from 'vue'
import Vuex from 'vuex'
import { logoutApi } from '@/api/user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    user: JSON.parse(localStorage.getItem('user')) || null,
    role: localStorage.getItem('role') !== null ? parseInt(localStorage.getItem('role')) : null
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER(state, user) {
      state.user = user
      state.role = user.role
      localStorage.setItem('user', JSON.stringify(user))
      localStorage.setItem('role', user.role)
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.user = null
      state.role = null
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      localStorage.removeItem('role')
    }
  },
  actions: {
    logout({ commit, state }) {
      if (state.token) {
        logoutApi().catch(() => {})
      }
      commit('CLEAR_AUTH')
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    isAdmin: state => state.role === 0
  }
})
